import {
  IMailingPriorityList,
  IServicesCategoryMailingList,
  IStrategyRegister,
} from './interfaces';
import { IMailingRuleParsedToStrategyActionsItem } from 'interfaces/Strategy';
import { FORM_MODE } from 'shared/enums';

export const strategyRegisterTitles = {
  [FORM_MODE.create]: 'Criação',
  [FORM_MODE.edit]: 'Edição',
  [FORM_MODE.view]: 'Visualização',
};

export const makeStrategyInitialValues = (
  lists: {
    [key: string]: IMailingRuleParsedToStrategyActionsItem[];
  },
  current?: IStrategyRegister,
): IStrategyRegister => {
  return {
    name: current?.name || '',
    status: current?.status || 'DRAFT',
    dateStatus: current?.dateStatus,
    executionPeriodicityInDays: current?.executionPeriodicityInDays || 0,
    selectedServiceCategories: Object.entries(lists).reduce(
      (
        total,
        [serviceCategoryId, mailingRuleList],
      ): IServicesCategoryMailingList => {
        total[serviceCategoryId] = mailingRuleList.reduce(
          (
            mailingObject,
            { id, activation, priority },
          ): IMailingPriorityList => {
            const currentPriorized = current
              ? current.selectedServiceCategories[serviceCategoryId]?.[id]
              : undefined;
            const newObject = {
              activation: currentPriorized?.activation || activation,
              priority: currentPriorized?.priority || priority || 0,
            };
            return (mailingObject = {
              ...mailingObject,
              [id]: newObject,
            });
          },
          {} as IMailingPriorityList,
        );
        return total;
      },
      {} as IServicesCategoryMailingList,
    ),
  };
};
